const $ = jQuery.noConflict();

'use strict';
const Login = {

	// DOM cache
	$loginForm: null,
	$loginErrors: null,
	$loginBtn: null,
	$lostPassForm: null,
	$lostPassErrors: null,
	$lostPassBtn: null,
	$popupLogin: null,
	$popupLostPass: null,
	$popupLostSuccess: null,
	$loginLostPassLink: null,
	$loginResetPassw: null,


	/** @description Initialize */
	init: function() {
		Login.$loginBtn = $('.js-login-button');
		Login.$loginForm = Login.$loginBtn.closest('form');
		Login.$loginErrors = $('.js-login-errors', Login.$loginForm);
		Login.$loginLostPassLink = $('.js-lost-pass-link');
		Login.$lostPassBtn = $('.js-login-lostpass-btn');
		Login.$lostPassForm = Login.$lostPassBtn.closest('form');
		Login.$lostPassErrors = $('.js-login-lostpass-errors', Login.$lostPassForm);
		Login.$popupLogin = $('.js-login-popup-login');
		Login.$popupLostPass = $('.js-login-popup-lostpass');
		Login.$popupLostSuccess = $('.js-login-popup-lostpasssuccess');
		Login.$loginResetPassw = $('.login-popup--new-password form');
		//console.log(Login.$loginResetPassw);
		this.bindLoginEvents();
		this.bindLostPassEvents();

		// auto popup
		this.autoShowLoginPopup();

		// popup selector
		//this.switchPopup('login');
		$('.js-popup-head-login-trigger').on('click', ()=> Login.switchPopup('login'));
	},

	// switch visible part
	switchPopup: (popup) => {
		Login.clearForm();
		Login.$popupLogin.toggle(popup === 'login');
		Login.$popupLostPass.toggle(popup === 'lost-password');
		Login.$popupLostSuccess.toggle(popup === 'lost-success');
	},

	// auto popup
	autoShowLoginPopup: () => {
		if ($('.js-auto-show-login-form').length) {
			Login.switchPopup('login');
			$('.js-popup-head-login-trigger').trigger('click');
		}
		if ($('.js-auto-show-lostpassword-form').length) {
			Login.switchPopup('lost-password');
			$('.js-popup-head-login-trigger').trigger('click');
		}
	},


	// ---------------------------------------------------------------------------
	//                             login functions
	// ---------------------------------------------------------------------------

	// attach event listeners
	bindLoginEvents: () => {
		const hideIcon = $('.js-popup__form-hide-password');
		const showIcon = $('.js-popup__form-show-password');

		hideIcon.on('click', function() {
			$(this).parent().find('input').attr('type', 'text');
			$(this).parent().find('.js-popup__form-hide-password').hide();
			$(this).parent().find('.js-popup__form-show-password').show();
		});

		showIcon.on('click', function() {
			$(this).parent().find('input').attr('type', 'password');
			$(this).parent().find('.js-popup__form-hide-password').show();
			$(this).parent().find('.js-popup__form-show-password').hide();
		});

		Login.$loginForm.on('submit', () => {return false;});
		Login.$loginBtn.on('click', Login.sendLoginRequest);
		Login.$loginLostPassLink.on('click', ()=> Login.switchPopup('lost-password'));
		Login.$loginResetPassw.on('submit', function(e) {
			Login.validateResetPassword(e);
		});
	},

	validateResetPassword: (e) => {
		const resetPassword1 = $('#new_password');
		const resetPassword2 = $('#confirm_password');
		const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;
		const errorHolder = $('.error-message');
		errorHolder.empty();
		if(!resetPassword1.val() || !resetPassword2.val()){
			if(!resetPassword1.val()){
				resetPassword1.parent().addClass('form-input-holder');
				resetPassword1.addClass('error');
				resetPassword1.parent().append('<span class="error-message">Required field</span>');
				e.preventDefault();
			}
			if(!resetPassword2.val()){
				resetPassword2.parent().addClass('form-input-holder');
				resetPassword2.addClass('error');
				resetPassword2.parent().append('<span class="error-message">Required field</span>');
				e.preventDefault();
			}
		} else if(resetPassword1.val() !== resetPassword2.val()){
			resetPassword1.parent().addClass('form-input-holder');
			resetPassword1.addClass('error');
			resetPassword1.parent().append('<span class="error-message">Passwords do not match</span>');
			e.preventDefault();
		} else if(!passwordRegex.test(resetPassword1.val())){
			resetPassword1.parent().addClass('form-input-holder');
			resetPassword1.addClass('error');
			resetPassword1.parent().append('<span class="error-message">Password must be at least 8 characters long and include at least one uppercase letter and one number.</span>');
			e.preventDefault();
		} else {
			resetPassword1.removeClass('error');
			resetPassword2.removeClass('error');
		}
	},

	// submit ajax request
	sendLoginRequest: () => {
		const insertedUsername = $('#login_email').val();
		const insertedPassword = $('#login_password').val();
		const insertedUsernameHolder = $('#login_email');
		const insertedPasswordHolder = $('#login_password');
		const errorTextUsername = insertedUsernameHolder.parent().find('.error-message');
		const errorTextPassword = insertedPasswordHolder.parent().find('.error-message');
		const errorMessage = 'Field is required';
		errorTextUsername.empty();
		errorTextPassword.empty();
		insertedUsernameHolder.removeClass('error');
		insertedPasswordHolder.removeClass('error');
		if(!insertedUsername || !insertedPassword){
			if(!insertedUsername){
				Login.handleError(insertedUsernameHolder, errorTextUsername, errorMessage);
			}
			if(!insertedPassword){
				Login.handleError(insertedPasswordHolder, errorTextPassword, errorMessage);
			}
		} else {
			// Regular expression for email validation
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (!emailRegex.test(insertedUsername)) {
				return;
			}

			$('.btn-loader').show();
			$('.js-login-button').hide();

			const data = {
				action: 'user_login',
				email: $('input[name=login_email]', Login.$loginForm).val(),
				pass: $('input[name=login_password]', Login.$loginForm).val(),
				nonce: $('#woocommerce-login-nonce', Login.$loginForm).val(),
				url: window.location.href,
			};
			Login.toggleLoginSpinner(true);
			Login.$loginErrors.html('');
			$.ajax({
				type: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: data,
				success: (response) => {
					if (response && response.success) {
						Login.onLoginSuccess(response);
					} else {
						Login.onLoginFailure(response);
					}
				},
				error: (jqXHR, textStatus) => Login.onLoginHardError(jqXHR, textStatus),
				complete: () => {
					Login.toggleLoginSpinner(false);
					$('.btn-loader').hide();
					$('.js-login-button').show();
				}
			});
		}
	},

	// show login spinner
	toggleLoginSpinner: (state) => {
		Login.$loginBtn.toggleClass('show-spinner', state);
	},

	// handle "success" response
	onLoginSuccess: (response) => {
		const urlParams = new URLSearchParams(window.location.search);
		const redirectUrl = response.redirect_url;
		if(urlParams.get('redirect')) {
			window.location.href = urlParams.get('redirect');
		} else {
			if(redirectUrl){
				window.location.href = redirectUrl;
			} else {
				window.location.href = window.fwsLocalized.siteUrl + '/my-account/';
			}
		}
	},

	clearForm: () => {
		$('.popup__form').find('input:not([type="submit"])').val('');
		$('.popup__form').find('.js-login-errors').text('');
	},

	// handle "error" response
	onLoginFailure: (response) => {
		let message = response && response.errors
			? response.errors.join('<br>')
			: 'Something went wrong.';
		if (response && response.errors) {
			// Check if any error contains "is not registered on this site."
			if (response.errors.some(error => error.includes('is not registered on this site.'))) {
				// Replace the error message
				message = 'Invalid username or password.';
			} else {
				// Join other errors
				message = response.errors.join('<br>');
			}
		}
		Login.$loginErrors.html(message);
	},

	// handle critical error
	onLoginHardError: function(jqXHR, textStatus) {
		let message = 'Something  went wrong.';
		if (jqXHR.responseText === '0' && jqXHR.status === 400) message = 'Something  went wrong: unknown action.';
		//if ()
		Login.onLoginFailure({error: message});
	},

	handleError: function(inputField, errorText, errorMessage) {
		inputField.addClass('error');
		inputField.parent().addClass('error-input');
		if (errorText.length === 0) {
			inputField.parent().append('<span class="error-message">' + errorMessage + '</span>');
		} else {
			errorText.text(errorMessage);
		}

		$('.fancybox-close-small').on('click', function() {
			inputField.removeClass('error');
			inputField.parent().removeClass('error-input');
			$('.error-message').remove();
		});
		$('body').on('click', function(e) {
			if(!$(e.target).is($('.js-popup-head *'))) {
				inputField.removeClass('error');
				inputField.parent().removeClass('error-input');
				$('.error-message').remove();
			}
		});
	},


	// ---------------------------------------------------------------------------
	//                           lost password functions
	// ---------------------------------------------------------------------------

	// attach event listeners
	bindLostPassEvents: () => {
		Login.$lostPassForm.on('submit', () => {return false;});
		Login.$lostPassBtn.on('click', Login.sendLostPassRequest);
	},

	sendLostPassRequest: () => {
		const data = {
			action: 'user_lost_password',
			email: $('input[name=lost_email]', Login.$lostPassForm).val(),
			step: 'lost',
		};
		Login.toggleLostPassSpinner(true);
		$('.popup__sign-up-box--submit>.btn-loader').show();
		$('.js-login-lostpass-btn').hide();
		Login.$lostPassErrors.html('');
		$.ajax({
			type: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: data,
			success: (response) => {
				if (response && response.success) {
					Login.onLostPassSuccess(response);
				} else {
					Login.onLostPassFailure(response);
				}
			},
			error: (jqXHR, textStatus) => Login.onLostPassHardError(jqXHR, textStatus),
			complete: () => {
				Login.toggleLostPassSpinner(false);
				$('.popup__sign-up-box--submit>.btn-loader').hide();
				$('.js-login-lostpass-btn').show();
			}
		});
	},

	// show lost password spinner
	toggleLostPassSpinner: (state) => {
		Login.$lostPassBtn.toggleClass('show-spinner', state);
	},

	// handle "success" response
	onLostPassSuccess: (response) => {
		Login.switchPopup('lost-success');
	},

	// handle "error" response
	onLostPassFailure: (response) => {
		// const message = response && response.errors
		// 	? response.errors.join('<br>')
		// 	: 'Something went wrong.';
		// 	console.log(response.errors);
		// Login.$lostPassErrors.html(message);
		let message;
		if (response && response.errors) {
			if (response.errors.includes('You must specify email address.')) {
				message = 'Field is required';
			} else {
				message = response.errors.join('<br>');
			}
			//console.log(response.errors);
		} else {
			message = 'Something went wrong.';
		}
		Login.$lostPassErrors.html(message);
	},

	// handle critical error
	onLostPassHardError: function(jqXHR, textStatus) {
		let message = 'Something  went wrong.';
		if (jqXHR.responseText === '0' && jqXHR.status === 400) message = 'Something  went wrong: unknown action.';
		Login.onLostPassFailure({error: message});
	},

};

export default Login;
